import { useState } from "react";

export const usePopup = <T,>(props?: {
  onOpen?: () => void;
  onClose?: () => void;
  onOk?: (data?: T | null) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState<T | null>(null);

  const open = (inputData?: T) => {
    setIsOpen(true);
    inputData && setData(inputData);
    props?.onOpen?.();
  };

  const close = () => {
    setIsOpen(false);
    setData(null);
    props?.onClose?.();
  };

  const onOk = () => {
    props?.onOk?.(data);
    setIsOpen(false);
    setData(null);
  };

  return { isOpen, open, close, onOk };
};

export type TUsePopupHook = ReturnType<typeof usePopup>;
